export enum RealEstateRoleEnum {
  MainCollateral = 'MainCollateral',
  BridgingCollateral = 'BridgingCollateral',
  AdditionalCollateral = 'AdditionalCollateral',
}
